<template>
  <v-container fluid class="px-12 py-5">
    <v-row>
      <v-col cols="6"
        ><breadcrumbs></breadcrumbs>
        <h1>Security Functions</h1></v-col
      >
      <v-col cols="6" class="text-right"
        ><v-btn
          @click="$router.push({ name: 'ochinUserSecurityFunctionFormCreate' })"
          color="primary"
          outlined
          class="mt-5"
          >Add</v-btn
        ></v-col
      >
    </v-row>
    <function-table :list="list"></function-table>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Breadcrumbs from "../Breadcrumbs";
import FunctionTable from "./Table";

export default {
  components: {
    Breadcrumbs,
    FunctionTable,
  },
  computed: {
    ...mapState({
      list: state => state.secFunction.list,
    }),
  },
  async created() {
    await Promise.all([this.getFunctionList(), this.getFunctionInputList()]);
  },
  methods: {
    navigate() {},
    ...mapActions({
      getFunctionInputList: "secFunctionInput/list",
      getFunctionList: "secFunction/list",
    }),
  },
};
</script>
